<template>
  <div class="h-full overflow-auto">
    <el-tabs
      v-model="activeName"
      class="h-[calc(100%-48px)] common-tab"
      @tab-click="settingActiveChange"
    >
      <el-tab-pane label="显示设置" name="displaySetting">
        <el-card
          class="w-full"
          :body-style="{ width: '100%', height: '100%', padding: '5px 10px' }"
        >
        </el-card>
        <el-card class="w-full mt-5px" :body-style="{ width: '100%', padding: '10px' }">
          <el-row :gutter="8" type="flex" align="middle" class="mt-5px">
            <el-col :span="8">
              <div class="w-full text-white text-12px">点选高亮</div>
            </el-col>
            <el-col :span="4" class="flex items-center">
              <el-switch
                v-model="pickupHighlight"
                @change="(e) => switchChange(e, 'pickUp.highlight')"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-col>
            <el-col :span="12" class="flex items-center">
              <el-color-picker
                v-model="pickupHighlightColor"
                size="small"
                @change="
                  (e) => {
                    colorPickerChange(e, 'pickup.color', false, 'string')
                  }
                "
                show-alpha
                color-format="rgb"
              ></el-color-picker>
              <el-input
                v-model="pickupHighlightColor"
                @change="
                  (e) => {
                    colorPickerChange(e, 'pickup.color', false, 'string')
                  }
                "
                placeholder=""
                size="mini"
              ></el-input>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="mt-5px">
            <el-col :span="8">
              <div class="w-full text-white text-12px">包围盒</div>
            </el-col>
            <el-col :span="4" class="flex items-center">
              <el-switch
                v-model="showSiegeBox"
                @change="(e) => switchChange(e, 'show.select.box')"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-col>
            <el-col :span="12" class="flex items-center"></el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="mt-5px">
            <el-col :span="8">
              <div class="w-full text-white text-12px">点选轮廓</div>
            </el-col>
            <el-col :span="4" class="flex items-center">
              <el-switch
                @change="(e) => switchChange(e, 'postprocess.outline')"
                v-model="showPickupOutline"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-col>
            <el-col :span="12" class="flex items-center">
              <el-color-picker
                v-model="pickupOutlineColor"
                size="small"
                show-alpha
                @change="
                  (e) => {
                    colorPickerChange(e, 'pickup.edgeColor', true, 'string')
                  }
                "
                color-format="rgb"
              ></el-color-picker>
              <el-input
                v-model="pickupOutlineColor"
                placeholder=""
                @change="
                  (e) => {
                    colorPickerChange(e, 'pickup.edgeColor', true, 'string')
                  }
                "
                size="mini"
              ></el-input>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="mt-5px">
            <el-col :span="8">
              <div class="w-full text-white text-12px">模型线框</div>
            </el-col>
            <el-col :span="4" class="flex items-center">
              <el-switch
                @change="(e) => switchChange(e, 'render.edge')"
                v-model="showModelBorder"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-col>
            <el-col :span="12" class="flex items-center"> </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-full text-white text-12px">点选背景虚化</div>
            </el-col>
            <el-col :span="9" class="flex items-center">
              <el-slider
                v-model="pickupBackgroundVirtual"
                :min="0"
                :max="1"
                class="w-full"
                :step="0.01"
                @input="
                  (e) => {
                    sliderChange(e, 'color.pickup.bkAlpha', 'float')
                  }
                "
              ></el-slider>
            </el-col>
            <el-col :span="7" class="flex items-center">
              <el-input-number
                v-model="pickupBackgroundVirtual"
                placeholder=""
                size="mini"
                @change="
                  (e) => {
                    sliderChange(e, 'color.pickup.bkAlpha', 'float')
                  }
                "
                controls-position="right"
                :min="0"
                :max="1"
                :step="0.01"
              ></el-input-number>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="w-full mt-5px" :body-style="{ width: '100%', padding: '10px' }">
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-full text-white text-12px">旋转速度</div>
            </el-col>
            <el-col :span="9" class="flex items-center">
              <el-slider
                v-model="minimumRotateSpeed"
                :min="0"
                :max="1"
                class="w-full"
                :step="0.01"
                @input="
                  (e) => {
                    sliderChange(e, 'mouse.rotate.speed', 'float')
                  }
                "
              ></el-slider>
            </el-col>
            <el-col :span="7" class="flex items-center">
              <el-input-number
                v-model="minimumRotateSpeed"
                placeholder=""
                size="mini"
                controls-position="right"
                :min="0"
                :max="1"
                :step="0.01"
                @change="
                  (e) => {
                    sliderChange(e, 'mouse.rotate.speed', 'float')
                  }
                "
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-full text-white text-12px">缩放速度</div>
            </el-col>
            <el-col :span="9" class="flex items-center">
              <el-slider
                v-model="minimumScaleSpeed"
                :min="0"
                :max="1"
                class="w-full"
                :step="0.01"
                @input="
                  (e) => {
                    sliderChange(e, 'mouse.scale.speed', 'float')
                  }
                "
              ></el-slider>
            </el-col>
            <el-col :span="7" class="flex items-center">
              <el-input-number
                v-model="minimumScaleSpeed"
                placeholder=""
                size="mini"
                controls-position="right"
                :min="0"
                :max="1"
                :step="0.01"
                @change="
                  (e) => {
                    sliderChange(e, 'mouse.scale.speed', 'float')
                  }
                "
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-full text-white text-12px">最小可见像素</div>
            </el-col>
            <el-col :span="9" class="flex items-center">
              <el-slider
                v-model="minimumVisiblePixel"
                :min="1"
                :max="100"
                class="w-full"
                :step="1"
                @input="
                  (e) => {
                    sliderChange(e, 'MinPixelCount', 'int')
                  }
                "
              ></el-slider>
            </el-col>
            <el-col :span="7" class="flex items-center">
              <el-input-number
                v-model="minimumVisiblePixel"
                placeholder=""
                size="mini"
                controls-position="right"
                :min="1"
                :max="100"
                :step="1"
                @change="
                  (e) => {
                    sliderChange(e, 'MinPixelCount', 'int')
                  }
                "
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="mt-5px">
            <el-col :span="8">
              <div class="w-full text-white text-12px">环境光阻挡</div>
            </el-col>
            <el-col :span="4" class="flex items-center">
              <el-switch
                @change="(e) => switchChange(e, 'postprocess.ssao')"
                v-model="ambientLightBlock"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-col>
            <el-col :span="12" class="flex items-center"> </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="mt-10px">
            <el-col :span="8">
              <div class="w-full text-white text-12px">全局光源</div>
            </el-col>
            <el-col :span="16" class="flex items-center">
              <el-select
                v-model="globalLightSource"
                popper-class="visualization-select-popper"
                class="w-full"
                size="mini"
                placeholder="--请选择--"
                @change="
                  (e) => {
                    selectChange(e, 'context.shaderIndex', 'int')
                  }
                "
              >
                <el-option
                  v-for="item in globalLightSourceOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-full text-white text-12px">环境光补偿</div>
            </el-col>
            <el-col :span="9" class="flex items-center">
              <el-slider
                v-model="ambientLightRestitution"
                :min="0"
                :max="1"
                class="w-full"
                :step="0.01"
                @input="
                  (e) => {
                    sliderChange(e, 'ambientIndenty', 'float')
                  }
                "
              ></el-slider>
            </el-col>
            <el-col :span="7" class="flex items-center">
              <el-input-number
                v-model="ambientLightRestitution"
                placeholder=""
                size="mini"
                @change="
                  (e) => {
                    sliderChange(e, 'ambientIndenty', 'float')
                  }
                "
                controls-position="right"
                :min="0"
                :max="1"
                :step="0.01"
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-full text-white text-12px">全局光源强度</div>
            </el-col>
            <el-col :span="9" class="flex items-center">
              <el-slider
                v-model="globalLightSourceStrength"
                :min="0"
                :max="1"
                class="w-full"
                @input="
                  (e) => {
                    sliderChange(e, 'diffuseIntensity', 'float')
                  }
                "
                :step="0.01"
              ></el-slider>
            </el-col>
            <el-col :span="7" class="flex items-center">
              <el-input-number
                v-model="globalLightSourceStrength"
                placeholder=""
                size="mini"
                controls-position="right"
                @input="
                  (e) => {
                    sliderChange(e, 'diffuseIntensity', 'float')
                  }
                "
                :min="0"
                :max="1"
                :step="0.01"
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-full text-white text-12px">高光强度</div>
            </el-col>
            <el-col :span="9" class="flex items-center">
              <el-slider
                v-model="highLightStrength"
                :min="0"
                :max="1.5"
                class="w-full"
                @input="
                  (e) => {
                    sliderChange(e, 'specularIntensity', 'float')
                  }
                "
                :step="0.01"
              ></el-slider>
            </el-col>
            <el-col :span="7" class="flex items-center">
              <el-input-number
                v-model="highLightStrength"
                placeholder=""
                size="mini"
                controls-position="right"
                @input="
                  (e) => {
                    sliderChange(e, 'specularIntensity', 'float')
                  }
                "
                :min="0"
                :max="1.5"
                :step="0.01"
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-full text-white text-12px">相机最小裁剪面</div>
            </el-col>
            <el-col :span="9" class="flex items-center">
              <el-slider
                v-model="minimumCuttingSurface"
                :min="0"
                :max="1"
                class="w-full"
                @input="
                  (e) => {
                    sliderChange(e, 'camera.minClip', 'float')
                  }
                "
                :step="0.001"
              ></el-slider>
            </el-col>
            <el-col :span="7" class="flex items-center">
              <el-input-number
                v-model="minimumCuttingSurface"
                placeholder=""
                size="mini"
                controls-position="right"
                @change="
                  (e) => {
                    sliderChange(e, 'camera.minClip', 'float')
                  }
                "
                :min="0"
                :max="1"
                :step="0.001"
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-full text-white text-12px">图片压缩比</div>
            </el-col>
            <el-col :span="9" class="flex items-center">
              <el-slider
                v-model="jpgQuality"
                :min="1"
                :max="100"
                class="w-full"
                @input="
                  (e) => {
                    sliderChange(e, 'webrtc.jpgQuality', 'int')
                  }
                "
                :step="1"
              ></el-slider>
            </el-col>
            <el-col :span="7" class="flex items-center">
              <el-input-number
                v-model="jpgQuality"
                placeholder=""
                size="mini"
                controls-position="right"
                @change="
                  (e) => {
                    sliderChange(e, 'webrtc.jpgQuality', 'int')
                  }
                "
                :min="0"
                :max="100"
                :step="1"
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="mt-10px">
            <el-col :span="8">
              <div class="w-full text-white text-12px">背面裁剪</div>
            </el-col>
            <el-col :span="16" class="flex items-center">
              <el-select
                v-model="backCutting"
                popper-class="visualization-select-popper"
                class="w-full"
                size="mini"
                placeholder="--请选择--"
                @change="
                  (e) => {
                    selectChange(e, 'cullface_mode', 'stringList')
                  }
                "
              >
                <el-option
                  v-for="item in backCuttingOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="mt-10px">
            <el-col :span="8">
              <div class="w-full text-white text-12px">天空盒</div>
            </el-col>
            <el-col :span="16" class="flex items-center">
              <el-select
                v-model="skyBox"
                popper-class="visualization-select-popper"
                class="w-full"
                size="mini"
                placeholder="--请选择--"
                @change="
                  (e) => {
                    selectChange(e, 'skybox.list', 'stringList')
                  }
                "
              >
                <el-option
                  v-for="item in skyBoxOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="mt-10px" v-if="skyBox === 'null'">
            <el-col :span="8">
              <div class="w-full text-white text-12px">选择颜色</div>
            </el-col>
            <el-col :span="16" class="flex items-center">
              <el-color-picker
                v-model="bgColor"
                size="small"
                @change="
                  (e) => {
                    colorPickerChange(e, 'bg.color', false, 'string')
                  }
                "
                show-alpha
                color-format="rgb"
              ></el-color-picker>
            </el-col>
          </el-row>
        </el-card>
        <!-- 锚点信息框选择 -->
        <!-- <el-card class="w-full mt-5px" :body-style="{ width: '100%', padding: '10px' }">
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-full text-white text-12px">锚点信息框</div>
            </el-col>
            <el-col :span="16" class="flex items-center">
              <el-select
                v-model="anchorPointInfoFrame"
                popper-class="document_select-popper"
                class="w-full"
                size="mini"
                placeholder="--请选择--"
                @change="
                  (e) => {
                    selectChange(e, 'anchorPointInfoFrame', 'string')
                  }
                "
              >
                <el-option
                  v-for="item in anchorPointInfoFrameOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-card> -->
      </el-tab-pane>
      <el-tab-pane label="漫游设置" name="roamingSetting">
        <el-card class="w-full mt-5px" :body-style="{ width: '100%', padding: '10px' }">
          <div class="w-full font-bold text-14px text-white">虚拟人物形象</div>
          <el-row :gutter="8" type="flex" align="middle" class="mt-5px">
            <el-col :span="8">
              <div class="w-full text-white text-12px">人物安全帽</div>
            </el-col>
            <el-col :span="16" class="flex items-center">
              <el-select
                v-model="safetyHelmet"
                popper-class="visualization-select-popper"
                class="w-full"
                size="mini"
                placeholder="--请选择--"
                @change="(e) => changeFigureMolding(e, 'setAvatarCapSkin')"
              >
                <el-option
                  v-for="item in safetyHelmetOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  class="flex items-center"
                >
                  <div class="h-15px w-15px ml-10px" :style="{ backgroundColor: item.color }"></div>
                  <span class="ml-10px">{{ item.label }}</span>
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="mt-5px">
            <el-col :span="8">
              <div class="w-full text-white text-12px">人物工作服</div>
            </el-col>
            <el-col :span="16" class="flex items-center">
              <el-select
                v-model="workingClothes"
                popper-class="visualization-select-popper"
                class="w-full"
                size="mini"
                placeholder="--请选择--"
                @change="(e) => changeFigureMolding(e, 'setAvatarBodySkin')"
              >
                <el-option
                  v-for="item in workingClothesOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  class="flex items-center"
                >
                  <div class="h-15px w-15px ml-10px" :style="{ backgroundColor: item.color }"></div>
                  <span class="ml-10px">{{ item.label }}</span>
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="w-full mt-5px" :body-style="{ width: '100%', padding: '10px' }">
          <el-row :gutter="8" type="flex" align="middle" class="mt-5px">
            <el-col :span="8">
              <div class="w-full text-white text-12px">人物移动速度</div>
            </el-col>
            <el-col :span="9" class="flex items-center">
              <el-slider
                v-model="mouseMoveSpeed"
                :min="1"
                :max="10"
                class="w-full"
                :step="1"
                @input="
                  (e) => {
                    changeWalkSpeed(e)
                  }
                "
              ></el-slider>
            </el-col>
            <el-col :span="7" class="flex items-center">
              <el-input-number
                v-model="mouseMoveSpeed"
                placeholder=""
                size="mini"
                @change="
                  (e) => {
                    changeWalkSpeed(e)
                  }
                "
                controls-position="right"
                :min="1"
                :max="10"
                :step="1"
              ></el-input-number>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="w-full mt-5px h-480px" :body-style="{ width: '100%', padding: '10px' }">
          <div class="w-full font-bold text-14px text-white">快捷键设置</div>
          <el-row :gutter="8" class="mt-5px">
            <el-col
              :span="12"
              class="flex items-center mt-10px"
              v-for="item in shortCutKeySettings"
              :key="item.name"
            >
              <div class="w-full text-white text-12px mr-5px">{{ item.label }}</div>
              <el-tooltip effect="dark" :content="item.value" placement="top" :open-delay="1000">
                <el-input
                  :value="item.value"
                  @focus="
                    (e) => {
                      keySetting(e, item, 1)
                    }
                  "
                  placeholder=""
                  size="mini"
                ></el-input>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-card>
      </el-tab-pane>
    </el-tabs>
    <div class="w-full mt-10px flex items-center justify-end">
      <!-- <el-button size="mini" @click="closeComponents" :loading="savaLoading">取消</el-button> -->
      <el-button
        type="primary"
        size="mini"
        :disabled="!$hasAccess('update')"
        @click="saveSettings"
        :loading="savaLoading"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import { PreferenceSettingApi } from '@wiz-api/cloud-render-management'
import cloudRender from '../../assets/js/model/index'

const preferenceApi = new PreferenceSettingApi()

export default {
  name: 'GlobalSetting',
  components: {},
  props: {
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      bgColor: 'rgba(255,255,255,1)', // 背景颜色
      savaLoading: false, // 保存时loading
      activeName: 'displaySetting',
      pickupHighlight: true, // 点选高亮
      pickupHighlightColor: 'rgba(255,255,255,1)', // 点选高亮颜色
      showSiegeBox: true, // 包围盒
      showPickupOutline: true, // 点选轮廓
      pickupOutlineColor: 'rgba(255,255,255,1)', // 点选轮廓颜色
      showModelBorder: true, // 模型线框
      pickupBackgroundVirtual: 0, // 点选背景虚化
      mouseMoveSpeed: 1, // 人物移动速度
      ambientLightBlock: true, // 环境光阻挡
      ambientLightRestitution: 0, // 环境光补偿
      globalLightSource: '', // 全局光源
      // 全局光源配置
      globalLightSourceOptions: [
        { value: 0, label: '默认' },
        { value: 1, label: '预设单灯' },
        { value: 2, label: '预设双灯' },
        { value: 3, label: '预设三灯' },
      ],
      globalLightSourceStrength: 0, // 全局光源强度
      minimumCuttingSurface: 0, // 摄像机最小裁剪面
      jpgQuality: 80, // 图片压缩比
      highLightStrength: 0, // 高光强度
      minimumVisiblePixel: 0, // 最小可见像素
      minimumRotateSpeed: 0, // 旋转速度
      minimumScaleSpeed: 0, // 缩放速度
      skyBox: '', // 天空盒
      skyBoxOptions: [],
      anchorPointInfoFrame: '', // 锚点信息框
      anchorPointInfoFrameOptions: [
        { value: 'null', label: '无' },
        { value: 'code', label: '对象编码' },
        { value: 'name', label: '对象名称' },
        { value: 'code+name', label: '编码+名称' },
      ],
      safetyHelmet: '', // 人物安全帽
      safetyHelmetOptions: [
        { value: 'yellow', label: '黄色', color: '#ffff00' },
        { value: 'blue', label: '蓝色', color: '#0000ff' },
        { value: 'white', label: '白色', color: '#ffffff' },
        { value: 'orange', label: '橙色', color: '#ffa500' },
        { value: 'red', label: '红色', color: '#ff0000' },
      ],
      backCutting: '', // 背面裁剪
      backCuttingOptions: [
        { value: 'none', label: '未设置' },
        { value: 'front', label: '显示正面' },
        { value: 'back', label: '显示背面' },
        { value: 'frontAndBack', label: '双面绘制' },
      ],
      workingClothes: '', // 人物工作服
      workingClothesOptions: [
        { value: 'red', label: '红色', color: '#ff0000' },
        { value: 'white', label: '白色', color: '#ffffff' },
        { value: 'yellow', label: '黄色', color: '#ffff00' },
        { value: 'blue', label: '蓝色', color: '#0000ff' },
        { value: 'gray', label: '浅灰色', color: '#dcdfe6' },
      ],
      roamingAngle: 'firstAngle', // 漫游视角
      shortCutKeySettings: [
        {
          label: '前进',
          name: '前进',
          value: 'W',
        },
        {
          label: '后退',
          name: '后退',
          value: 'S',
        },
        {
          label: '向左移动',
          name: '向左移动',
          value: 'A',
        },
        {
          label: '向右移动',
          name: '向右移动',
          value: 'D',
        },
        {
          label: '向上仰视',
          name: '向上仰视',
          value: 'I',
        },
        {
          label: '向下俯视',
          name: '向下俯视',
          value: 'K',
        },
        {
          label: '左转',
          name: '左转',
          value: 'J',
        },
        {
          label: '右转',
          name: '右转',
          value: 'L',
        },
        {
          label: '跳起',
          name: '跳起',
          value: 'Space',
        },
        {
          label: '无重力跳',
          name: '无重力跳',
          value: 'Z+Space',
        },
        {
          label: '奔跑',
          name: '奔跑',
          value: 'Shift',
        },
        {
          label: '蹲下',
          name: '蹲下',
          value: 'Ctrl',
        },
        {
          label: '垂直向上',
          name: '垂直向上移动',
          value: 'Q',
        },
        {
          label: '垂直向下',
          name: '垂直向下移动',
          value: 'E',
        },
        {
          label: '穿墙',
          name: '开启/关闭人物穿墙',
          value: 'C',
        },
        {
          label: '开/关失重',
          name: '开启/关闭人物飞行模式',
          value: 'Comma',
        },
        // {
        //   label: '增加速度',
        //   name: '增加漫游前进速度',
        //   value: '+',
        // },
        // {
        //   label: '减少速度',
        //   name: '减少漫游前进速度',
        //   value: '-',
        // },
      ],
      walkingSpeed: 0, // 行走速度
      squatMoveSpeed: 0, // 蹲下移动速度
      runSpeed: 0, // 奔跑速度
      sliderChangeTimerOut: null, // 滑动条防抖
      orignPlayerSettings: [], // 初始设置
      orignHotKeysSettings: {}, // 初始漫游设置
      orignFigureSettings: {}, // 初始人物形象
      settingEnd: false,
      settingAllOptions: [
        // 旋转速度
        { name: 'mouse.rotate.speed', type: 'float', value: '' },
        // 缩放速度
        { name: 'mouse.scale.speed', type: 'float', value: '' },
        // 锚点信息框
        { name: 'anchorPointInfoFrame', type: 'string', value: '' },
        // 点选高亮
        { name: 'pickUp.highlight', type: 'bool', value: '' },
        // 背景颜色
        { name: 'bg.color', type: 'string', value: '' },
        // 点选高亮颜色
        { name: 'pickup.color', type: 'string', value: '' },
        // 显示包围盒
        { name: 'show.select.box', type: 'bool', value: '' },
        // 点选轮廓
        { name: 'postprocess.outline', type: 'bool', value: '' },
        // 点选轮廓颜色
        { name: 'pickup.edgeColor', type: 'string', value: '' },
        // 模型线框
        { name: 'render.edge', type: 'bool', value: '' },
        // 点选背景虚化
        { name: 'color.pickup.bkAlpha', type: 'float', value: '' },
        // 摄像机最小裁剪面
        { name: 'MinPixelCount', type: 'int', value: '' },
        // 环境光阻挡
        { name: 'postprocess.ssao', type: 'bool', value: '' },
        // 点选高亮
        { name: 'postprocess', type: 'bool', value: '' },
        // 环境光补偿
        { name: 'ambientIndenty', type: 'float', value: '' },
        // 全局光源
        { name: 'context.shaderIndex', type: 'int', value: '' },
        // 全局光源强度
        { name: 'diffuseIntensity', type: 'float', value: '' },
        // 高光强度
        { name: 'specularIntensity', type: 'float', value: '' },
        // 摄像机最小裁剪面
        { name: 'camera.minClip', type: 'float', value: '' },
        // 图片压缩比
        { name: 'webrtc.jpgQuality', type: 'int', value: '' },
        // 天空盒
        { name: 'skybox.list', type: 'stringList', value: '' },
        // 背面裁剪
        { name: 'cullface_mode', type: 'stringList', value: '' },
        // 绘制天空
        { name: 'shader.sky', type: 'bool', value: true },
        // 地图设置
        { name: 'panorama.show', type: 'bool', value: '' },
        { name: 'map.pos', type: 'stringList', value: '' },
        { name: 'map.dir', type: 'stringList', value: '' },
        { name: 'map.size.x', type: 'int', value: '' },
        { name: 'map.size.y', type: 'int', value: '' },
        { name: 'map.scale.x', type: 'double', value: '' },
        { name: 'map.scale.y', type: 'double', value: '' },
      ],
      userPreferenceSettings: {},
    }
  },
  computed: {
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
  },
  async created() {
    await this.getPreferenceSettings()
    this.getAllSetting()
  },
  beforeDestroy() {
    document.oncontextmenu = null
    document.onkeydown = null
    this.closeComponents()
    this.setPreferenceSettings()
  },
  methods: {
    // 获取用户偏好设置
    async getPreferenceSettings() {
      const [err, res] = await preferenceApi.getCurrentUserSetting()
      if (!err && res && res.extraProperties) {
        this.userPreferenceSettings = res.extraProperties
      }
    },
    // 设置用户偏好设置
    async setPreferenceSettings() {
      if (this.userPreferenceSettings.Show) {
        const showSettings = await cloudRender.Setting.getAll(this.player)
        _.forIn(this.userPreferenceSettings.Show, (value, key) => {
          const settingInfo = _.find(showSettings.data || [], ['name', key])
          if (settingInfo) {
            let currentValue = ''
            if (settingInfo.type === 'bool') {
              currentValue = value === 'true' || value === true
            } else if (
              settingInfo.type === 'int' ||
              settingInfo.type === 'float' ||
              settingInfo.type === 'double'
            ) {
              currentValue = _.toNumber(value)
            } else {
              currentValue = value
            }
            cloudRender.Setting.set(this.player, {
              name: key,
              type: settingInfo.type,
              value: currentValue,
            })
          }
        })
      }
      const roamingSettings = this.userPreferenceSettings.RoamTrance || []
      _.forIn(roamingSettings, (value, key) => {
        let settingKeys = []
        if (this.userPreferenceSettings.RoamTrance) {
          const keysJson = JSON.parse(value)
          settingKeys = keysJson[0] || []
        } else {
          settingKeys = value[0] || []
        }
        cloudRender.Walking.setHotKeys(this.player, { name: key, code: settingKeys })
      })
      const RoamingSpeed = roamingSettings?.RoamingSpeed || 1
      cloudRender.Walking.setAvatarSpeed(this.player, RoamingSpeed)
      const figureSettings = this.userPreferenceSettings.People
      const skinObj = {
        body: figureSettings.avatarBodySkin,
        head: figureSettings.avatarCapSkin,
      }
      cloudRender.Walking.setAvatarSkin(this.player, 'GongRen', skinObj)
    },
    // 保存设置
    async saveSettings() {
      this.$confirm('是否保存当前设置！', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false,
      })
        .then(async () => {
          this.savaLoading = true
          // 获取当前player显示设置
          const currentDisplaySettings = await cloudRender.Setting.getAll(this.player)
          const filterDisplaySettings = _.filter(currentDisplaySettings.data || [], (item) => {
            return _.findIndex(this.settingAllOptions, ['name', item.name]) !== -1
          })
          const roamingData = await cloudRender.Walking.getAllHotKey(this.player)
          const roamingRes = _.reduce(
            roamingData.data || [],
            (obj, item) => {
              obj[item.label] = item.code
              return obj
            },
            {}
          )
          roamingRes.RoamingSpeed = await cloudRender.Walking.getAvatarSpeed(this.player)
          const jsonData = {
            Show: filterDisplaySettings,
            RoamTrance: roamingRes,
            People: {
              avatarCapSkin: this.safetyHelmet,
              avatarBodySkin: this.workingClothes,
            },
          }
          const saveRes = await cloudRender.Setting.saveSetting(
            this.player,
            `data://../apps/${this.modelSetting.folderName}/settings.json`,
            JSON.stringify(jsonData)
          )
          this.savaLoading = false
          if (saveRes) {
            this.$message.success('保存设置成功！')
          } else {
            this.$message.warning('保存设置失败！')
          }
        })
        .catch((err) => {})
    },
    // 关闭设置
    async closeComponents() {
      // 获取当前player显示设置
      const currentDisplaySettings = await cloudRender.Setting.getAll(this.player)
      const filterCurrentDisplaySettings = _.filter(currentDisplaySettings.data || [], (item) => {
        return _.findIndex(this.settingAllOptions, ['name', item.name]) !== -1
      })
      const filterEffectSettings = _.filter(filterCurrentDisplaySettings, (item) => {
        return _.find(this.settingAllOptions, (el) => {
          return el.name === item.name && el.type === item.type
        })
      })
      // 是否有更新过设置
      const isUpdateDisplay = _.every(this.orignDisplaySettings, (item) => {
        const currentItemSetting = _.find(filterEffectSettings, (el) => {
          return el.name === item.name && el.type === item.type
        })
        return currentItemSetting && currentItemSetting.value === item.value
      })
      // 获取当前漫游按键设置
      const hotKeysData = await cloudRender.Walking.getAllHotKey(this.player)
      const currentRoamingSettings = _.reduce(
        hotKeysData.data || [],
        (obj, item) => {
          obj[item.label] = item.code
          return obj
        },
        {}
      )
      const currentKeys = Object.getOwnPropertyNames(currentRoamingSettings)
      // 判断是否有更新设置
      const isUpdateRoaming = _.every(currentKeys, (item) => {
        return (
          currentRoamingSettings[item][0] &&
          this.orignHotKeysSettings[item][0] &&
          _.isEmpty(
            _.difference(currentRoamingSettings[item][0], this.orignHotKeysSettings[item][0])
          )
        )
      })
      if (
        !isUpdateDisplay ||
        !isUpdateRoaming ||
        this.safetyHelmet !== this.orignFigureSettings.avatarCapSkin ||
        this.workingClothes !== this.orignFigureSettings.avatarBodySkin
      ) {
        this.$confirm('是否保存当前设置！', '提示', {
          confirmButtonText: '保存',
          cancelButtonText: '取消',
          type: 'warning',
          lockScroll: false,
        })
          .then(async () => {
            this.savaLoading = true
            const displayParams = filterCurrentDisplaySettings
            _.forIn(currentRoamingSettings, (value, key) => {
              currentRoamingSettings[key] = JSON.stringify(value)
            })
            const speedData = await cloudRender.Walking.getAvatarSpeed(this.player)
            currentRoamingSettings.RoamingSpeed = speedData.data
            // 人物形象设置
            const skinParams = {
              avatarCapSkin: this.safetyHelmet,
              avatarBodySkin: this.workingClothes,
            }
            const jsonData = {
              Show: displayParams,
              RoamTrance: currentRoamingSettings,
              People: skinParams,
            }

            this.savaLoading = false
            const saveRes = await cloudRender.Setting.saveSetting(
              this.player,
              `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/settings.json`,
              JSON.stringify(jsonData)
            )
            if (saveRes) {
              this.$message.success('保存设置成功！')
            } else {
              this.$message.warning('保存设置失败！')
            }
          })
          .catch(async () => {
            // 还原更新之前的设置
            const currentPlayerSettings = await cloudRender.Setting.getAll(this.player)
            _.forIn(this.orignPlayerSettings, (value, key) => {
              // 找到对应设置的值类型（int,float,double,bool,string）
              const settingInfo = _.find(currentPlayerSettings.data || [], ['name', key])
              if (settingInfo) {
                let currentValue = ''
                if (settingInfo.type === 'bool') {
                  currentValue = value === 'true' || value === true
                } else if (
                  settingInfo.type === 'int' ||
                  settingInfo.type === 'float' ||
                  settingInfo.type === 'double'
                ) {
                  currentValue = _.toNumber(value)
                } else {
                  currentValue = value
                }
                cloudRender.Setting.set(this.player, {
                  name: key,
                  type: settingInfo.type,
                  value: currentValue,
                })
              }
            })
            _.forIn(this.orignHotKeysSettings, (value, key) => {
              const settingKeys = value[0] || []
              cloudRender.Walking.setHotKeys(this.player, { name: key, code: settingKeys })
            })
            const skinObj = {
              body: this.orignFigureSettings.avatarBodySkin,
              head: this.orignFigureSettings.avatarCapSkin,
            }
            cloudRender.Walking.setAvatarSkin(this.player, 'GongRen', skinObj)
          })
      }
    },
    // 切换设置内容
    settingActiveChange(e) {
      if (e.name === 'roamingSetting') {
        document.oncontextmenu = () => {
          return false
        }
        document.onkeydown = (e) => {
          e = window.event || e
          if (
            (e.keyCode >= 112 && e.keyCode <= 123) ||
            e.keyCode === 9 ||
            e.ctrlKey ||
            e.altKey ||
            e.shiftKey
          ) {
            e.preventDefault()
            return false
          }
          return true
        }
      } else {
        document.oncontextmenu = null
        document.onkeydown = null
      }
    },
    // 获取所有设置
    async getAllSetting() {
      const settingJsonData = await cloudRender.Setting.getSettingData(
        this.player,
        `data://../apps/${this.modelSetting.folderName}/settings.json`
      )
      let settingsData = {}
      if (settingJsonData && settingJsonData.data) {
        settingsData = JSON.parse(settingJsonData.data)
      }
      if (settingsData.Show) {
        this.orignDisplaySettings = settingsData.Show
      } else {
        const allDisplaySettings = await cloudRender.Setting.getAll(this.player)
        this.orignDisplaySettings = allDisplaySettings.data
      }
      if (settingsData.RoamTrance) {
        this.orignHotKeysSettings = settingsData.RoamTrance
        this.mouseMoveSpeed = settingsData.RoamTrance.RoamingSpeed
      } else {
        const hotKeysData = await cloudRender.Walking.getAllHotKey(this.player)
        this.orignHotKeysSettings = hotKeysData.data || []
        const speedData = await cloudRender.Walking.getAvatarSpeed(this.player)
        this.mouseMoveSpeed = speedData.data
      }
      if (settingsData.People) {
        this.figureSkin = settingsData.People
      } else {
        this.figureSkin = {
          avatarCapSkin: 'white',
          avatarBodySkin: 'red',
        }
      }
      this.orignFigureSettings = this.figureSkin
      this.safetyHelmet = this.figureSkin.avatarCapSkin
      this.workingClothes = this.figureSkin.avatarBodySkin
      const playerSettings = _.cloneDeep(this.orignDisplaySettings)
      const roamingSettings = _.cloneDeep(this.orignHotKeysSettings)
      this.setDisplaySettingsValue(playerSettings)
      this.setRoamingSettingsValue(roamingSettings)
      _.forEach(this.orignDisplaySettings, (item) => {
        cloudRender.Setting.set(this.player, {
          name: item.name,
          type: item.type,
          value: item.value,
        })
      })
      _.forIn(this.orignHotKeysSettings, (value, key) => {
        const settingKeys = value[0] || []
        cloudRender.Walking.setHotKeys(this.player, { name: key, code: settingKeys })
      })
      const skinObj = {
        body: this.orignFigureSettings.avatarBodySkin,
        head: this.orignFigureSettings.avatarCapSkin,
      }
      cloudRender.Walking.setAvatarSkin(this.player, 'GongRen', skinObj)
    },
    // 查询对应设置值
    getSettingDetailValue(name, data) {
      const settingInfo = _.find(data, ['name', name])
      if (settingInfo) {
        return settingInfo.value
      }
      return ''
    },
    // 设置页面值
    async setDisplaySettingsValue(data) {
      // 天空盒可选项
      const skyBoxList = await cloudRender.Setting.get(this.player, 'skybox.list')
      const skyBox = skyBoxList.data && skyBoxList.data.length ? skyBoxList.data[0] : {}
      this.skyBoxOptions = _.map(skyBox.dataSource, (item) => {
        return { value: item, label: item }
      })
      // 点选高亮——bool
      this.pickupHighlight = this.getSettingDetailValue('pickUp.highlight', data)
      // 点选高亮颜色
      this.pickupHighlightColor = this.colorToRgba(this.getSettingDetailValue('pickup.color', data))
      // 背景颜色
      this.bgColor = this.colorToRgba(this.getSettingDetailValue('bg.color', data))
      // 包围盒——bool
      this.showSiegeBox = this.getSettingDetailValue('show.select.box', data)
      // 点选轮廓——bool
      this.showPickupOutline = this.getSettingDetailValue('postprocess.outline', data)
      // 点选轮廓颜色
      this.pickupOutlineColor = this.colorToRgba(
        this.getSettingDetailValue('pickup.edgeColor', data),
        true
      )
      // 模型线框——bool
      this.showModelBorder = this.getSettingDetailValue('render.edge', data)
      // 点选背景虚化
      this.pickupBackgroundVirtual = _.floor(
        this.getSettingDetailValue('color.pickup.bkAlpha', data),
        2
      )
      // 摄像机最小裁剪面
      this.minimumVisiblePixel = _.toNumber(this.getSettingDetailValue('MinPixelCount', data))
      this.minimumRotateSpeed = _.toNumber(this.getSettingDetailValue('mouse.rotate.speed', data))
      this.minimumScaleSpeed = _.toNumber(this.getSettingDetailValue('mouse.scale.speed', data))
      // 环境光阻挡——bool
      this.ambientLightBlock = this.getSettingDetailValue('postprocess.ssao', data)
      // 环境光补偿
      this.ambientLightRestitution = _.floor(this.getSettingDetailValue('ambientIndenty', data), 2)
      // 全局光源
      this.globalLightSource = this.getSettingDetailValue('context.shaderIndex', data)
      // 全局光源强度
      this.globalLightSourceStrength = _.floor(
        this.getSettingDetailValue('diffuseIntensity', data),
        2
      )
      // 高光强度
      this.highLightStrength = _.floor(this.getSettingDetailValue('specularIntensity', data), 2)
      // 摄像机最小裁剪面
      this.minimumCuttingSurface = _.floor(this.getSettingDetailValue('camera.minClip', data), 2)
      // 图片压缩比
      this.jpgQuality = _.toNumber(this.getSettingDetailValue('webrtc.jpgQuality', data))
      // 天空盒
      this.skyBox = this.getSettingDetailValue('skybox.list', data)
      // 背面裁剪
      this.backCutting = this.getSettingDetailValue('cullface_mode', data)
      // 锚点信息框——anchorPointInfoFrame
      this.anchorPointInfoFrame = this.getSettingDetailValue('anchorPointInfoFrame', data)
    },
    // 获取所有按键设置
    async setRoamingSettingsValue(data) {
      _.forEach(this.shortCutKeySettings, (item) => {
        const currentKey = data[item.name]
        if (currentKey && currentKey.length) {
          item.value = cloudRender.Walking.hotKeyMap[currentKey[0]]
        }
      })
      const speedData = await cloudRender.Walking.getAvatarSpeed(this.player)
      this.mouseMoveSpeed = speedData.data
    },
    // 字符串转Boolean
    stringToBoolean(value) {
      return value === 'true' || value === true
    },
    // 颜色转换
    colorToRgba(value, special = false) {
      const color = value.split(',')
      if (special) {
        return `rgba(${color[0] * 1},${color[1] * 1},${color[2] * 1},${color[3] / 255})`
      }
      return `rgba(${color[0] * 255},${color[1] * 255},${color[2] * 255},${color[3] / 1})`
    },
    // 漫游按键设置
    keySetting(e, item) {
      let currentKeys = []
      e.target.onkeydown = (event) => {
        const keyStatus = cloudRender.Walking.hotKeyMap[event.keyCode]
        if (!keyStatus) {
          this.$message.warning('按键无效，请重新输入！')
          return
        }
        if (!_.includes(currentKeys, keyStatus)) {
          currentKeys.push(keyStatus)
        }
        item.value = !_.isEmpty(currentKeys) ? currentKeys.join('+') : ''
      }
      e.target.onkeyup = async () => {
        e.srcElement.blur()
        const settingKeys = currentKeys
        if (!_.isEmpty(settingKeys)) {
          const currentSettingKeys = _.map(settingKeys, (el) => {
            return cloudRender.Walking.hotKeyMap[el]
          })
          if (!_.isEmpty(currentSettingKeys)) {
            const setRes = await cloudRender.Walking.setHotKeys(this.player, {
              name: item.name,
              code: currentSettingKeys,
            })
          }
        }
        currentKeys = []
      }
    },
    // switch状态改变时触发
    switchChange(e, val) {
      if ((val === 'postprocess.ssao' || val === 'postprocess.outline') && e) {
        cloudRender.Setting.set(this.player, { name: 'postprocess', type: 'bool', value: true })
      }
      cloudRender.Setting.set(this.player, { name: val, type: 'bool', value: e })
    },
    // 下拉框选择改变
    selectChange(e, val, type) {
      cloudRender.Setting.set(this.player, { name: val, type, value: e })
      if (val === 'skybox.list') {
        cloudRender.Setting.set(this.player, {
          name: 'shader.sky',
          type: 'bool',
          value: e !== 'null',
        })
      }
    },
    // 滑动条值改变触发
    sliderChange(e, val, type) {
      if (this.sliderChangeTimerOut) clearTimeout(this.sliderChangeTimerOut)
      this.sliderChangeTimerOut = setTimeout(() => {
        cloudRender.Setting.set(this.player, { name: val, type, value: e })
      }, 100)
    },
    // 人物移动速度发生变化时
    changeWalkSpeed(e) {
      cloudRender.Walking.setAvatarSpeed(this.player, e)
    },
    // 颜色选择器值改变
    colorPickerChange(e, val, special, type) {
      const rgbList = e.slice(5, -1).split(',')
      const rgb = _.map(rgbList, (item, index) => {
        let res = ''
        if (index !== rgbList.length - 1) {
          res = special ? _.toNumber(item) : _.round(_.toNumber(item) / 255, 2)
        } else {
          res = special ? item * 255 : _.toNumber(item)
        }
        return res
      })
      cloudRender.Setting.set(this.player, { name: val, type, value: rgb.join(',') })
    },
    // 更换人物形象
    async changeFigureMolding(e, name) {
      const skin = {
        body: '',
        head: '',
      }
      if (name === 'setAvatarBodySkin') {
        skin.body = e
      } else if (name === 'setAvatarCapSkin') {
        skin.head = e
      }
      cloudRender.Walking.setAvatarSkin(this.player, 'GongRen', skin)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__content {
  height: calc(100% - 50px);

  .el-tab-pane {
    overflow-y: auto;
    height: 100%;
  }
}
</style>
